export default {
  

  apiIpPort:process.env.REACT_APP_API_ENDPOINT,
  apiBaseUrl:process.env.REACT_APP_API_BASEURL , 
  
  
  // QA
  // apiIpPort:"http://13.234.79.73:8080",
  // apiBaseUrl:"/foxmatrixapp/v1/api/"

//production
// apiIpPort:"https://services.foxmatrix.com",
// apiBaseUrl:"/foxmatrixapp/v1/api/" 

  
//    //Staging
// apiIpPort:"http://13.127.87.149:8080",
// apiBaseUrl:"/foxmatrixapp/v1/api/" 
//   //  base url


    
    // // Sahdeep local Host
    // apiIpPort:"http://192.168.2.35:8080",
    // apiBaseUrl:"/v1/api/"    

    //time_feature
    // apiIpPort:"http://13.127.87.149:8080",
    // apiBaseUrl:"/foxmatrixapp/v1/api/"

}